import { Opportunity, Team } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { TeamOpportunityEntityConfig } from "./config";
import { TeamOpportunityFilters } from "./filters";
import { TeamOpportunityMethods } from "./methods";

@HyperEntity("team-opportunity", TeamOpportunityEntityConfig)
export class TeamOpportunity extends extender(
  TeamOpportunityFilters,
  TeamOpportunityMethods,
) {
  @Fields.string({ dbName: "team_id" })
  teamId = "";

  @Fields.string({ dbName: "opportunity_id" })
  opportunityId = "";

  @Relations.toOne<TeamOpportunity, Opportunity>(
    () => Opportunity,
    "opportunityId",
  )
  opportunity?: Opportunity;

  @Relations.toOne<TeamOpportunity, Team>(() => Team, "teamId")
  team?: Team;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
